<div class="add-order-medicine">
  <form [formGroup]="addOrderMedicineForm" class="add-order-medicine__form">
    <div class="add-order-medicine__fields row g-2">
      <div class="col-md-6">
        <mat-form-field
          appearance="outline"
          class="add-order-medicine__field add-order-medicine__field--search"
          subscriptSizing="dynamic"
        >
          <mat-icon matPrefix>search</mat-icon>
          <input
            required
            [disabled]="isLoading"
            data-testid="add-medicine-name"
            type="text"
            placeholder="Search for medicine"
            aria-label="Search for medicine"
            matInput
            formControlName="medicineFilter"
            [matAutocomplete]="auto"
          />
          <mat-autocomplete
            data-testid="add-medicine-autocompletion-list"
            panelClass="add-order-medicine-autocomplete-panel"
            (optionSelected)="medicineSelected($event)"
            autoActiveFirstOption
            #auto="matAutocomplete"
          >
            @for (med of medicine; track med) {
              <mat-option [value]="med">{{ med.name }}</mat-option>
            }
          </mat-autocomplete>
          @if (addOrderMedicineForm.get('medicineFilter')?.invalid) {
            <mat-error>Medicine is invalid</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <mat-form-field appearance="outline" class="add-order-medicine__field" subscriptSizing="dynamic">
          <mat-label>Dosage type</mat-label>
          <mat-select
            required
            data-testid="add-medicine-dosage-type"
            [disabled]="isLoading || dosageTypes.length === 0"
            formControlName="dosageType"
            (selectionChange)="getMedicineDosagePackageTypes($event)"
          >
            @for (type of dosageTypes; track type) {
              <mat-option [value]="type">
                {{ type.additional_information }}
              </mat-option>
            }
          </mat-select>
          @if (addOrderMedicineForm.get('dosageType')?.invalid) {
            <mat-error>Dosage type is invalid</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <mat-form-field appearance="outline" class="add-order-medicine__field" subscriptSizing="dynamic">
          <mat-label>Package type</mat-label>
          <mat-select
            (selectionChange)="packageTypeSelected($event)"
            required
            data-testid="add-medicine-package-type"
            formControlName="packageType"
          >
            @for (type of medicineDosageTypePackageTypes; track type) {
              <mat-option [value]="type">
                {{ type.package_type.type }} ({{ type.contained_quantity }})
              </mat-option>
            }
          </mat-select>
          @if (addOrderMedicineForm.get('packageType')?.invalid) {
            <mat-error>Package type is invalid</mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="add-order-medicine__actions">
      <button
        [disabled]="addOrderMedicineForm.invalid || isLoading || !selectedDosageType"
        data-testid="add-medicine-add-button"
        type="button"
        (click)="addOrderItem()"
        mat-flat-button
        color="primary"
        class="add-order-medicine__submit"
      >
        <mat-icon>add</mat-icon> Add medicine
      </button>
    </div>
  </form>
</div>
